// extracted by mini-css-extract-plugin
export default {"theHeader":"TheHeader_theHeader__rjKlZ","logo":"TheHeader_logo__kfXYx"};